/**
 * Cookie Utilities
 *
 * Simple cookie management for popup dismissal tracking.
 */

/**
 * Set a cookie
 */
export function setCookie(name: string, value: string, days: number): void {
	let expires = '';

	if (days > 0) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = `; expires=${date.toUTCString()}`;
	}

	document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/; SameSite=Lax`;
}

/**
 * Get a cookie value
 */
export function getCookie(name: string): string {
	const nameEQ = `${name}=`;
	const cookies = document.cookie.split(';');

	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i];
		while (cookie.charAt(0) === ' ') {
			cookie = cookie.substring(1);
		}
		if (cookie.indexOf(nameEQ) === 0) {
			return decodeURIComponent(cookie.substring(nameEQ.length));
		}
	}

	return '';
}

/**
 * Delete a cookie
 */
export function deleteCookie(name: string): void {
	setCookie(name, '', -1);
}
